/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';

import type { IBaseResponse } from '@home/types/common';
import {
  IProjectGRActionItemsFilterConditionsDTO,
  IProjectGRActionItemsFetchParams,
  IProjectGRActionItemsDownloadParams,
  IProjectGRActionItemsEditParams,
  IProjectGRActionItemProjectDTO,
} from '@gp/types/grActionItems';

/**
 * 获取GR Action Items页面 筛选器选项数据
 * @returns GR Action Items页面 筛选器选项数据
 */
export const fetchProjectGRActionItemsFilterConditions =
  async (): IBaseResponse<IProjectGRActionItemsFilterConditionsDTO> => {
    const res: any = await http({
      url: '/api/v1/globalpedia_pc/action_items/selects',
      method: 'GET',
      params: {},
      rawData: true,
    });

    const { data, ...restRes } = res || {};
    const { bo: businessOwners, ...restData } = data || {};
    const dataTmp = { ...restData, business_owner: businessOwners };
    return { ...restRes, data: dataTmp };
  };

/**
 * 获取GR Action Items页面表格数据
 * @param params 参数对象，具体定义参见IProjectGRActionItemsFetchParams类型定义
 * @returns GR Action Items页面表格数据
 */
export const fetchProjectGRActionItemsProjects = (
  params: IProjectGRActionItemsFetchParams,
): IBaseResponse<IProjectGRActionItemProjectDTO[]> => {
  return http({
    url: '/api/v1/globalpedia_pc/action_items',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};

/**
 * 获取指定Project、指定Milestone下的GR Action Items列表数据
 * @param params 参数对象
 * @returns GR Action Items列表数据
 */
export const fetchProjectMilestoneGRActionItems = (params: {
  project_id: string;
  milestone_id: string;
}): IBaseResponse<Pick<IProjectGRActionItemProjectDTO, 'gr_action_items'>> => {
  return http({
    url: '/api/v1/globalpedia_pc/action_items/all_action_items',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};

export const updateProjectGRActionItemsProject = (params: IProjectGRActionItemsEditParams) => {
  return http({
    url: '/api/v1/globalpedia_pc/action_items/edit',
    method: 'POST',
    data: params,
    rawData: true,
  });
};

/**
 * 下载GR Action Items页面表格数据
 * @param params 参数对象，具体定义参见IProjectGRActionItemsDownloadParams类型定义
 * @returns 文件流
 */
export const downloadProjectGRActionItems = (params: IProjectGRActionItemsDownloadParams): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/action_items/download',
    method: 'POST',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};
